<template>
    <span :class="className">        
    </span>
</template>
<script>
    
    export default {
        name : 'k-text',
        props: ['type', 'skin'],
        computed: {
            className(){
                const {type,skin} = this
                if(skin == 1){
                    return type == 1 ? 'up-text-1' : type == 2 ? 'down-text-1' : ''
                }
                return type == 1 ? 'up-text' : type == 2 ? 'down-text' : ''
            }
        },
    }
</script>